import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ReceiptModel } from 'src/app/shared/model/receipt.model';
import { DonorCrmService } from 'src/app/shared/services/donor-crm/donor-crm.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';
import { ValidationCallbackData } from 'devextreme-angular/common';
import ValidationEngine from 'devextreme/ui/validation_engine';

@Component({
  selector: 'app-donor-crm-dashboard',
  templateUrl: './donor-crm-dashboard.component.html',
  styleUrl: './donor-crm-dashboard.component.scss',
})
export class DonorCrmDashboardComponent {
  public showDonorActivityPopup: boolean = false;
  public isShohayAdmin: boolean = false;

  public sessionUser = this.localStorageService.getSessionUser();
  public receiptObject: ReceiptModel = new ReceiptModel();

  public allFundraisers = [];

  public donorActivity = {
    total_donors: 0,
    total_fund_raised: 0,
    direct_donation_amount: 0,
    campaign_donation_amount: 0,
    recent_donations: [],
    top_donors: [],
  };

  public recentActivity = [];
  public donatedDonations = [];
  public pledgingDonations = [];

  public selectedStatus: string = 'ALL';

  public today: Date = new Date();
  public oneYearAgo: Date = new Date(
    this.today.getFullYear() - 1,
    this.today.getMonth(),
    this.today.getDate(),
    this.today.getHours(),
    this.today.getMinutes(),
    this.today.getSeconds(),
    this.today.getMilliseconds()
  );

  public startDate: Date = new Date(
    this.today.getFullYear(),
    this.today.getMonth() - 5,
    this.today.getDate(),
    this.today.getHours(),
    this.today.getMinutes(),
    this.today.getSeconds(),
    this.today.getMilliseconds()
  );
  public endDate: Date = this.today;

  public DonorRecognetitonPopup = false;

  public top10Donors = [];
  constructor(
    private readonly router: Router,
    private readonly donorCrmService: DonorCrmService,
    private readonly sharedService: CommonSharedServiceService,
    public readonly localStorageService: LocalStorageService,
    private readonly utilitiesService: UtilitiesService
  ) {
    this.isShohayAdmin = this.localStorageService.getIsSuperAdmin();
  }

  ngOnInit() {
    this.getAllDonationList();

    this.sharedService.ngoSelectionAction$.subscribe((action) => {
      this.getAllDonationList();
    });
    this.sharedService.updateReceiptPopupState(false);
  }

  public showReceiptPopup(receipt: any): void {
    this.receiptObject = new ReceiptModel();
    this.sharedService.updateReceiptPopupState(true);
    this.receiptObject.firstColumnName = 'Campaign';
    this.receiptObject.secondColumnName = 'NGOs Name';
    this.receiptObject.thirdColumnName = 'Donated Amount + Transaction Fee';
    this.receiptObject.secondColumnValue = receipt.ngo_name;
    this.receiptObject.thirdColumnValue = Number(
      +receipt.amount + +receipt.transaction_fees
    );
    this.receiptObject.total_amount = Number(
      +receipt.amount + +receipt.transaction_fees
    );
    this.receiptObject.invoice_no = String(
      Math.floor(Math.random() * (10000 - 200 + 1)) + 200
    );
    this.receiptObject.invoice_to = receipt.name;
    this.receiptObject.invoice_date = new Date();
    this.receiptObject.payment_method = 'Card';
    this.receiptObject.firstColumnValue = receipt.campaign_title;
  }

  public customizeLabel(point: any): string {
    return `${point.valueText}`;
  }

  public getAllDonationList(): void {
    this.donorCrmService.getDonorCrmDashboard().subscribe({
      next: (result: any) => {
        this.donorActivity.total_donors = result.total_donors || 0;
        this.donorActivity.recent_donations = result.recent_donations;
        this.donorActivity.direct_donation_amount =
          result.direct_donation_amount || 0;
        this.donorActivity.campaign_donation_amount =
          result.campaign_donation_amount || 0;
        this.donorActivity.total_fund_raised =
          this.donorActivity.direct_donation_amount +
          this.donorActivity.campaign_donation_amount;

        this.donorActivity.top_donors = result?.top_donors.map((donor) => ({
          ...donor,
          profile_img: this.utilitiesService.jsonParse(donor?.profile_img),
        }));
        this.donorActivity.recent_donations = result?.recent_donations.map(
          (donation) => ({
            ...donation,
            payment_receipt: this.utilitiesService.jsonParse(
              donation?.payment_receipt
            ),
          })
        );
      },
    });
  }

  public getAllDonorCrmActivity(): void {
    this.donorCrmService
      .getDonorCrmDashboardActivity(
        this.startDate.toISOString(),
        this.endDate.toISOString(),
        this.selectedStatus
      )
      .subscribe({
        next: (result: any) => {
          this.donatedDonations = result.donated_donations;
          this.pledgingDonations = result.pledging_donations;
          this.filterRecentActivity();
        },
      });
  }

  public filterRecentActivity(): void {
    if (this.selectedStatus === 'ALL') {
      this.recentActivity = [
        ...this.donatedDonations,
        ...this.pledgingDonations.map((donation) => ({
          ...donation,
          amount: donation.pledged_amount,
          status: donation.pledging_status,
        })),
      ];
    } else if (this.selectedStatus === 'DONATED') {
      this.recentActivity = [...this.donatedDonations];
    } else if (this.selectedStatus === 'PLEDGED') {
      this.recentActivity = this.pledgingDonations.map((donation) => ({
        ...donation,
        amount: donation.pledged_amount,
        status: donation.pledging_status,
      }));
    }
  }

  public updateDateRange(event: any) {
    const { isValid } = ValidationEngine.validateGroup('validationGroup');

    if (event && event.value) {
      this.startDate = event.value[0]; // First value is startDate
      this.endDate = event.value[1]; // Second value is endDate

      if (isValid) {
        this.getAllDonorCrmActivity();
      }
    }
  }

  public showDonorActivityPopupOpen() {
    this.showDonorActivityPopup = true;
    this.getAllDonorCrmActivity();
  }

  public onStatusChanged(e: any) {
    this.selectedStatus = e.value;
    this.getAllDonorCrmActivity();
  }

  public topDonorsNGO() {
    this.donorCrmService.getTopDonors().subscribe({
      next: (result: any) => {
        this.top10Donors = result?.map((donor) => ({
          ...donor,
          profile_img: this.utilitiesService.jsonParse(donor?.profile_img),
        }));
      },
    });
  }
  public donorRecognition() {
    this.topDonorsNGO();
    this.DonorRecognetitonPopup = true;
  }

  public navigateToProfile(data: any) {
    const encryptedParams = this.localStorageService.encryptObjectUrl({
      donorId: data.donor_id,
      ngoId: data.ngo_id,
    });
    if (
      this.localStorageService.getSelectedRole().short_form === 'system_admin'
    ) {
      this.router.navigate(['/admin/donor-crm/donor-info'], {
        queryParams: { data: encryptedParams },
      });
    } else {
      this.router.navigate(['/dashboard/donor-crm/donor-info'], {
        queryParams: { data: encryptedParams },
      });
    }
  }

  public viewPaymentReceipt(data: any) {
    window.open(data?.url, '_blank');
  }

  validateDateRange({ value: [startDate, endDate] }: ValidationCallbackData) {
    const maxEndDate = new Date(startDate);
    maxEndDate.setMonth(maxEndDate.getMonth() + 5);
    return endDate <= maxEndDate;
  }
}
